import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/functions'
import { ArtistContact } from 'nfty-common/lib/model/artist.model';
import firebaseConfig from '../config/firebase.config.json';

const FirebaseApp = firebase.initializeApp(firebaseConfig);
const FirebaseDB = firebase.database(FirebaseApp);
const FirebaseFn = firebase.functions(FirebaseApp);

const { REACT_APP_DB_HOST, REACT_APP_DB_PORT, REACT_APP_FN_HOST, REACT_APP_FN_PORT } = process.env;
if (REACT_APP_DB_HOST && REACT_APP_DB_PORT) {
    console.info('Using local emulator for firebase Database');

    // eslint-disable-next-line react-hooks/rules-of-hooks
    FirebaseDB.useEmulator(REACT_APP_DB_HOST, +REACT_APP_DB_PORT);
}

if (REACT_APP_FN_HOST && REACT_APP_FN_PORT) {
    console.info('Using local emulator for firebase Functions');

    // eslint-disable-next-line react-hooks/rules-of-hooks
    FirebaseFn.useEmulator(REACT_APP_FN_HOST, +REACT_APP_FN_PORT);
}

export type FirebaseRef = firebase.database.Reference;

export type DataSnap = firebase.database.DataSnapshot;

export const publicRef = FirebaseDB.ref('public');

export const submitContact = (data: ArtistContact) => FirebaseDB.ref('public/webContacts').push().set(data);

export const onSubmitBid = FirebaseFn.httpsCallable('onBidSubmit');